interface AboutHeroProps {
  onOpenModal: () => void;
}

export default function AboutHero({ onOpenModal }: AboutHeroProps) {
  return (
    <section className="relative w-full pt-14 overflow-hidden">
      <div className="absolute inset-0">
        <img
          alt="Gracie and Lily, the white fluffy Bichon Frise sisters, in a sunny flower garden with a stone bridge and stream"
          className="w-full h-full object-cover object-top"
          src="https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/5443114284c5bf88289d19fd10496fe8.png"
        />
        <div className="absolute inset-0 bg-primary-950/65"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/90 via-primary-950/60 to-primary-950/90"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 py-16 md:py-24 flex flex-col items-center text-center gap-4 md:gap-6">
        <img
          alt="Gracie & Lily Adventures logo"
          className="h-28 md:h-40 w-auto object-contain drop-shadow-[0_8px_24px_rgba(0,0,0,0.35)]"
          src="https://public.readdy.ai/ai/img_res/91ea3fda-8705-4921-ab9c-220fa8418490.png"
        />

        <div className="bg-accent-500 text-white px-5 py-2 rounded-full font-bold text-sm inline-flex items-center gap-2">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="fa-solid fa-paw text-sm"></i>
          </span>
          A Children's Book & Gift Brand
        </div>

        <h1 className="text-3xl md:text-5xl font-black text-white leading-tight [text-shadow:0_2px_10px_rgba(0,0,0,0.85),0_1px_3px_rgba(0,0,0,0.9)]">
          About Gracie & Lily Adventures
        </h1>

        <p className="text-white text-base md:text-lg font-medium max-w-2xl leading-relaxed [text-shadow:0_1px_6px_rgba(0,0,0,0.9),0_1px_2px_rgba(0,0,0,0.9)]">
          Gracie & Lily Adventures is a United States children's book and gift brand inspired by
          real-life Bichon Frise sisters, Gracie and Lily. We create illustrated children's stories,
          personalized books, digital books, seasonal stories, and themed merchandise for families
          with children ages 3-8.
        </p>

        <div className="flex flex-wrap gap-3 justify-center">
          <div className="bg-primary-950/60 backdrop-blur-sm border border-white/30 text-white px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap [text-shadow:0_1px_4px_rgba(0,0,0,0.9)]">
            13 Magical Adventures
          </div>
          <div className="bg-primary-950/60 backdrop-blur-sm border border-white/30 text-white px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap [text-shadow:0_1px_4px_rgba(0,0,0,0.9)]">
            Ages 3-8
          </div>
          <div className="bg-primary-950/60 backdrop-blur-sm border border-white/30 text-white px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap [text-shadow:0_1px_4px_rgba(0,0,0,0.9)]">
            Real Dogs, Real Stories
          </div>
          <div className="bg-primary-950/60 backdrop-blur-sm border border-white/30 text-white px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap [text-shadow:0_1px_4px_rgba(0,0,0,0.9)]">
            Personalized Books
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 mt-2">
          <a
            href="https://gracie-and-lilys-adventures.myshopify.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-accent-500 text-white px-6 md:px-8 py-3 rounded-lg font-bold text-base whitespace-nowrap cursor-pointer hover:bg-accent-600 transition-colors text-center"
          >
            Shop Books
          </a>
          <a
            href="https://www.etsy.com/shop/GracieandLilysAdv"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-primary-600 px-6 md:px-8 py-3 rounded-lg font-bold text-base whitespace-nowrap cursor-pointer hover:bg-white/90 transition-colors text-center flex items-center justify-center gap-2"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shopping-basket-2-line text-lg"></i>
            </span>
            Shop on Etsy
          </a>
          <button
            onClick={() => onOpenModal()}
            className="border-2 border-white text-white px-6 md:px-8 py-3 rounded-lg font-bold text-base whitespace-nowrap cursor-pointer hover:bg-white hover:text-primary-500 transition-colors"
          >
            Claim Free Gift
          </button>
        </div>
      </div>
    </section>
  );
}